export enum OutsourcedWorkerServiceType {
  LA = 1,
  CABISTA = 2,
}
